/* unplugin-vue-components disabled */import { render } from "./fav-icon.vue?vue&type=template&id=278472ca"
import script from "./fav-icon.vue?vue&type=script&lang=js"
export * from "./fav-icon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/fav-icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "278472ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('278472ca', __exports__)) {
    api.reload('278472ca', __exports__)
  }
  
  module.hot.accept("./fav-icon.vue?vue&type=template&id=278472ca", () => {
    api.rerender('278472ca', render)
  })

}


export default __exports__